import React from "react";

const Accordiantb = ({ data }) => {
    // console.log("acc", { data })
    return (
        <div className="overflow-x-auto h-96">
            <table className="min-w-full h-56 border border-gray-300 divide-y divide-gray-200">
                <thead className="bg-gray-100 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">PPL</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">PL</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Chassis number</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Average FE</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Avg Km run per month</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Vehicle Registration Number</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Driving Behaviour Cluster</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                                <td className="px-4 py-2 text-sm text-gray-800">{row.PPL}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">{row.PL}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">{row.ASSET_NUMBER}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">{row.Average_FE}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">{row.Average_KM_run}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">{row.VEHICLE_REGISTRATION_NUMBER}</td>
                                <td className="px-4 py-2 text-sm text-gray-800">  {row?.driving_behaviour_cluster || "NA"}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className="px-4 py-2 text-center text-gray-500">
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div >
    );
};

export default Accordiantb;
